import Vue from "vue";
import PortalVue from "portal-vue";

window.axios = require("axios");

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');
let base_url = document.head.querySelector('meta[name="base-url"]');

if (token) {
    window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
} else {
    console.error(
        "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token"
    );
}

window.Vue = Vue;
Vue.prototype.$base_url = base_url.content;

Vue.use(PortalVue);

Vue.component("litigation", require("./components/Litigation.vue").default);

const app = new Vue({
    el: "#wrapper",
});
